import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ADMIN_CREATE_WITH_ROVO } from '@confluence/named-routes/entry-points/routes.ts';
import { LazyCreateWithRovoPage } from '@confluence/site-settings/entry-points/CreateWithRovoPage.ts';
import { ADMIN_CREATE_WITH_ROVO_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/createWithRovoConstants.ts';

export const AdminCreateWithRovoRoute: {
	(): React.JSX.Element;
	ROUTE_NAME: string;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyCreateWithRovoPage />;

AdminCreateWithRovoRoute.ROUTE_NAME = ADMIN_CREATE_WITH_ROVO.name;

AdminCreateWithRovoRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_CREATE_WITH_ROVO_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
